import { z } from "zod";

const GPNSVersionSchema = z.object({
  year: z.string(),
  version: z.number(),
});

const GPNSTypeSchema = z.object({
  type: z.string(),
  version: GPNSVersionSchema,
});

const GPNSVlanTagSchema = z.object({
  tag: z.string(),
});

const GPNSVlanSchema = z.object({
  number: z.string(),
  name: z.string(),
  nickname: z.string().nullable().optional(),
  application: z.string().nullable().optional(),
  netmask: z.array(z.string()),
  cidr: z.string(),
  networkAddress: z.string().nullable().optional(),
  ip: z.string().nullable().optional(),
  routable: z.boolean(),
  wiredStatus: z.boolean().nullable().optional(),
  dhcp: z.boolean(),
  dhcpLow: z.string().nullable().optional(),
  dhcpHigh: z.string().nullable().optional(),
  dhcpRouter: z.string().nullable().optional(),
  internetAccess: z.boolean(),
  proxyArp: z.boolean(),
  securityLevel: z.number(),
  version: z.array(GPNSVersionSchema),
  type: z.array(GPNSTypeSchema),
  tags: z.array(GPNSVlanTagSchema),
});

export type GPNSVlan = z.infer<typeof GPNSVlanSchema>;
export type GPNSVersion = z.infer<typeof GPNSVersionSchema>;
export type GPNSType = z.infer<typeof GPNSTypeSchema>;

export const GPNSVlanListSchema = z.array(GPNSVlanSchema);
